import AbstractDataAdapter from '../AbstractDataAdapter';

class LevelDataAdapter extends AbstractDataAdapter {
  /**
   *
   * @returns {string[]}
   */
  static get allowedFields() {
    return ['name', 'isSubLevel', 'positionIndex', 'surface'];
  }

  /**
   *
   * @returns {string[]}
   */
  static get requiredFields() {
    return ['name'];
  }
}

export default LevelDataAdapter;
